import EditBeautyPreferencesModal from 'components/GlobalModals/EditBeautyPreferencesModal/EditBeautyPreferencesModal';
import { withEditBeautyPreferencesModalProps } from 'viewModel/globalModals/editBeautyPreferencesModal/withEditBeautyPreferencesModalProps';

export default withEditBeautyPreferencesModalProps(EditBeautyPreferencesModal);
